
import { ResponsiveIframe } from '../layouts/ResponsiveIframe.js';

export const LandingPage = {
  onLoad: function() {
    if ($('.template-landing-page').length) {
      ResponsiveIframe.onLoad();
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/modules/LandingPage.js